import React, { useState } from 'react';
import { formatRetirementNumber } from '../../config/wilder_requests/index.js';
import {
  Card,
  Header,
  Title,
  Badges,
  Badge,
  SubBadge,
  Grid,
  Field,
  LongText,
  Actions,
  QuantityHighlight
} from './CarbonRetirements.styles';

export default function CarbonRetirementCard({ r }) {
  const [openPurpose, setOpenPurpose] = useState(false);
  const [openSerial, setOpenSerial] = useState(false);

  const date = r['Created Date'] ? new Date(r['Created Date']) : null;
  const dateBR = date ? date.toLocaleDateString('pt-BR', { dateStyle: 'medium' }) : '-';

  const copy = (txt) => navigator.clipboard?.writeText(txt);

  return (
    <Card>
      <Header>
        <Title title={r['Asset name'] || ''}>
          {r['Asset name'] || '—'}
        </Title>
        <Badges>
          {r.Standard && <Badge title={`Padrão: ${r.Standard}`}>{r.Standard}</Badge>}
          {r.Vintage && <SubBadge title={`Vintage: ${r.Vintage}`}>{r.Vintage}</SubBadge>}
          {r['Asset Type'] && <SubBadge title={`Tipo: ${r['Asset Type']}`}>{r['Asset Type']}</SubBadge>}
        </Badges>
      </Header>

      {/* Quantity em destaque */}


      <Grid>
        <Field>
          <small>Tipo de Projeto</small>
          <p title={r['Project type'] || ''}>{r['Project type'] || '—'}</p>
        </Field>
        <Field>
          <small>Data de Criação</small>
          <p>{dateBR}</p>
        </Field>
        <Field>
          <small>Beneficiário</small>
          <p title={r.Beneficiary || ''}>{r.Beneficiary || '—'}</p>
        </Field>
        <Field>
          <small>Retirante (Retiree)</small>
          <p title={r.Retiree || ''}>{r.Retiree || '—'}</p>
        </Field>
      </Grid>

      <Field>
        <small>Propósito</small>
        <LongText $expanded={openPurpose} title={r.Purpose || r.Notes || ''}>
          {r.Purpose || r.Notes || '—'}
        </LongText>
        {(r.Purpose || r.Notes) && (
          <Actions>
            <button className="secondary" onClick={() => setOpenPurpose(v => !v)}>
              {openPurpose ? 'Mostrar menos' : 'Ver mais'}
            </button>
          </Actions>
        )}
      </Field>

      <Grid>
        <Field>
          <small>TXID</small>
          <LongText $expanded={false} title={r.txid || ''}>{r.txid || '—'}</LongText>
          {r.txid && (
            <Actions>
              <button onClick={() => copy(r.txid)}>Copiar TXID</button>
            </Actions>
          )}
        </Field>
        <Field>
          <small>Serial Numbers</small>
          <LongText $expanded={openSerial} title={r['Serial Numbers'] || ''}>
            {r['Serial Numbers'] || '—'}
          </LongText>
          {r['Serial Numbers'] && (
            <Actions>
              <button className="secondary" onClick={() => setOpenSerial(v => !v)}>
                {openSerial ? 'Mostrar menos' : 'Ver mais'}
              </button>
              <button onClick={() => copy(r['Serial Numbers'])}>Copiar Seriais</button>
            </Actions>
          )}
        </Field>
      </Grid>

      {(r.certificate) && (
        <Actions>
          <a href={r.certificate} target="_blank" rel="noreferrer">Ver Certificado</a>
        </Actions>
      )}

      <QuantityHighlight>
        <span className="quantity-value">{formatRetirementNumber(r.Quantity)}</span>
        <span className="quantity-label">créditos compensados</span>
      </QuantityHighlight>
    </Card>
  );
}
